import React from 'react';
import {
  Title,
  Text,
  Button,
  Image,
  Box,
  Modal,
} from '@mantine/core';
import '@justinribeiro/lite-youtube';
import { IconBrandGithub, IconLink, IconBrandYoutube } from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import './Entry.css';

interface PortfolioEntryProps {
  title: string;
  content?: React.ReactNode;
  description?: string;
  screenshot?: string;
  link?: string;
  github?: string;
  youtube?: string;
  [key: string]: any;
}

export default function PortfolioEntry({
  title,
  description,
  link,
  screenshot,
  content,
  github,
  youtube,
  ...otherProps
}: PortfolioEntryProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'portfolio.generic',
  });
  const [screenshotModalOpen, setScreenshotModalOpen] = React.useState(false);
  const [youtubeModalOpen, setYoutubeModalOpen] = React.useState(false);

  return (
    <Box className="genericContainer" {...otherProps}>
      <Modal
        opened={screenshotModalOpen}
        onClose={() => setScreenshotModalOpen(false)}
        size="auto"
        title={title}
      >
        <Image src={screenshot} alt="screenshot" radius="md" width="80vw" />
      </Modal>
      <Modal
        opened={youtubeModalOpen}
        onClose={() => setYoutubeModalOpen(false)}
        size="80%"
        title={title}
      >
        {/* <iframe
          width="100%"
          height={window.innerHeight * 0.7}
          src={`https://www.youtube.com/embed/${youtube}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media;
          gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        /> */}
        <lite-youtube videoid={youtube} />
      </Modal>

      <Title order={2} sx={{ marginBottom: '8px' }}>{title}</Title>
      <Box className="contentContainer">
        <Box className="screenshotContainer">
          {!!screenshot && (
          <Image
            src={screenshot}
            alt="screenshot"
            width="350px"
            radius="md"
            withPlaceholder
            onClick={() => setScreenshotModalOpen(true)}
          />
          )}
        </Box>
        <Box className="informationContainer">
          <Text size="lg" sx={{ margin: '4px', marginBottom: '8px' }}>{description}</Text>
          <Box className="buttonsContainer">
            {!!link && (
            <Button
              size="md"
              rightIcon={<IconLink />}
              component="a"
              href={link}
              target="_blank"
              rel="noreferrer"
            >
              {t('websiteButton')}
            </Button>
            )}
            {!!github && (
            <Button
              size="md"
              color="dark"
              rightIcon={<IconBrandGithub />}
              component="a"
              href={github}
              target="_blank"
              rel="noreferrer"
            >
              {t('gitButton')}
            </Button>
            )}
            {!!youtube && (
            <Button
              size="md"
              color="red"
              rightIcon={<IconBrandYoutube />}
              onClick={() => setYoutubeModalOpen(true)}
            >
              {t('watchExampleButton')}
            </Button>
            )}
          </Box>
        </Box>
      </Box>
      <Box className="contentContainer">
        {content}
      </Box>
    </Box>
  );
}
